import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { iStaffBaseURL } from "../../constants/Urls";
import { notify } from "../../functions/function";
import { readableDateTime } from "../../functions/timeFormat";
import SmallLoadingSpinner from "../../components/SmallLoadingSpinner";
import { dispatchUpdatePendingPlacements } from "./helperFunctions";

// import { copyWithin } from "core-js/fn/array";

const handleSubmit = (
  currentRow,
  status,
  userToken,
  handleClose,
  dispatch,
  id,
  pendingPlacements,
  isClient,
  setState
) => {
  setState({ loading: true });
  axios
    .put(
      iStaffBaseURL + `/handler/placements/${currentRow.id}/timesheet`,
      {
        clock_in_time: currentRow.timesheet.clock_in_time,
        clock_in_latitude: currentRow.timesheet.clock_in_latitude,
        clock_in_longitude: currentRow.timesheet.clock_in_longitude,
        approval_status: isClient
          ? currentRow.timesheet.approval_status
          : status,
        client_approval_status: isClient
          ? status
          : currentRow.timesheet.client_approval_status,
      },
      {
        headers: { Authorization: `Token ${userToken}` },
      }
    )
    .then((response) => {
      handleClose();
      setState({ loading: false });
      var notifcationMessage = "Successfully";
      if (isClient) {
        notifcationMessage = notifcationMessage + " Client " + status;
      } else {
        notifcationMessage = notifcationMessage + " iStaff " + status;
      }

      notify("Success", notifcationMessage, "success");

      dispatchUpdatePendingPlacements(
        dispatch,
        pendingPlacements,
        id,
        isClient,
        status
      );
    })
    .catch((error) => {
      setState({ loading: false });
      notify("Failed", "Error Occured. Please Try Again", "danger");
      console.log(error);
    });
};

const ConfirmModal = ({
  show,
  handleClose,
  status,
  isClient,
  rows,
  id,
  dispatch,
  userToken,
  pendingPlacements,
}) => {
  const [state, setState] = useState({
    loading: false,
  });

  var currentRow = rows.filter((x) => x.id === id[0])[0];
  var type;

  if (isClient) {
    type = "Client";
  } else {
    type = "iStaff";
  }
  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {type} {status} Following Timesheet
          </Modal.Title>
        </Modal.Header>
        <Modal.Body> Timesheet Information</Modal.Body>
        <Modal.Body>
          Id : {currentRow.employee.user.id}
          {" Name :"}
          {currentRow.employee.user.first_name}{" "}
          {currentRow.employee.user.last_name}
          {", at  location "}
          {currentRow.location}
          {" on the "}
          {readableDateTime(currentRow.start_time)}
        </Modal.Body>

        <Modal.Footer>
          {!state.loading ? (
            <>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>

              <Button
                variant="primary"
                onClick={() => {
                  handleSubmit(
                    currentRow,
                    (status = "Approved"),
                    userToken,
                    handleClose,
                    dispatch,
                    id,
                    pendingPlacements,
                    isClient,
                    setState
                  );
                }}
              >
                Approve
              </Button>

              <Button
                variant="danger"
                onClick={() => {
                  handleSubmit(
                    currentRow,
                    (status = "Declined"),
                    userToken,
                    handleClose,
                    dispatch,
                    id,
                    pendingPlacements,
                    isClient,
                    setState
                  );
                }}
              >
                Decline
              </Button>
            </>
          ) : (
            <SmallLoadingSpinner />
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmModal;
